import moment from "moment-timezone";

import { useT } from "@repo/transifex";

import { useMinuteTick } from "./use-minute-tick";

type DateBadge = {
  disabled: boolean;
  badge: string | undefined;
};

function getBadgeByDates(
  deadline: number | null,
  onset: number | null,
  timezone: string,
  t: ReturnType<typeof useT>
): DateBadge {
  if (!deadline && !onset) return { disabled: false, badge: undefined };

  let disabled = false;
  let badge;

  if (onset) {
    const isToday = moment
      .unix(onset)
      .tz(timezone)
      .isSame(moment.tz(timezone), "day");
    const isOnsetPassed = isToday && onset < moment().unix();

    if (isToday && !isOnsetPassed) {
      disabled = true;
      badge = t("Available after {date}", {
        date: moment.unix(onset).tz(timezone).format("HH:mm")
      });
    }
  }

  if (deadline && !badge) {
    disabled = false;
    badge = t("Buy before {date}", {
      date: moment.unix(deadline).tz(timezone).format("HH:mm")
    });
  }

  return { disabled, badge };
}

export function useDateBadge(
  deadline: number | null,
  onset: number | null,
  timezone: string
): DateBadge {
  const t = useT();
  useMinuteTick(Boolean(deadline || onset));
  return getBadgeByDates(deadline, onset, timezone, t);
}
